import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const SWIPER_OPTIONS = {
  allowTouchMove: false,
  autoHeight: false,
  effect: "fade",
  fadeEffect: { crossFade: true },
  loop: false,
  nested: true,
  speed: 450,
  watchSlidesProgress: true,
};

function syncButtons(buttons, activeIndex) {
  buttons.forEach((button, index) => {
    const isActive = index === activeIndex;
    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-selected", String(isActive));

    if (isActive) {
      button.setAttribute("aria-current", "true");
    } else {
      button.removeAttribute("aria-current");
    }
  });
}

function initSubSwiper(panel, selector, buttonSelector) {
  const element = panel.querySelector(selector);
  const buttons = Array.from(panel.querySelectorAll(buttonSelector));

  if (!element || !buttons.length) return null;

  const desktopInitialSlide = Number(element.dataset.initialSlide || 0);
  const initialSlide = window.matchMedia("(orientation: portrait)").matches
    ? 0
    : desktopInitialSlide;
  const swiper = new Swiper(element, {
    ...SWIPER_OPTIONS,
    initialSlide,
  });

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const indexValue = button.dataset.ruleIndex !== undefined
        ? button.dataset.ruleIndex
        : button.dataset.rewardIndex;
      const index = Number(indexValue || 0);
      swiper.slideTo(index);
    });
  });

  const sync = () => syncButtons(buttons, swiper.activeIndex);
  swiper.on("slideChange", sync);
  sync();

  return swiper;
}

function initCalendar(panel) {
  const stage = panel.querySelector(".calendar-stage");
  if (!stage) return;

  const toggle = stage.querySelector(".month-button");
  const options = stage.querySelector(".month-options");
  const monthButtons = Array.from(stage.querySelectorAll("[data-month]"));
  const monthViews = Array.from(stage.querySelectorAll("[data-calendar-month]"));

  const closeOptions = () => {
    if (!toggle || !options) return;
    options.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
  };

  toggle?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    const willOpen = options.hidden;
    options.hidden = !willOpen;
    toggle.setAttribute("aria-expanded", String(willOpen));
  });

  monthButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const month = button.dataset.month;

      toggle.textContent = month;
      monthViews.forEach((view) => {
        view.hidden = view.dataset.calendarMonth !== month;
      });
      closeOptions();
    });
  });

  stage.addEventListener("click", (event) => {
    if (!event.target.closest(".calendar-filter")) closeOptions();
  });
}

window.addEventListener("load", () => {
  const root = document.querySelector("#tournament");
  if (!root) return;

  const panels = Array.from(root.querySelectorAll(".game-content"));
  const contentSwipers = [];
  const childSwipers = [];

  panels.forEach((panel) => {
    const ruleSwiper = initSubSwiper(panel, "[data-rule-swiper]", "[data-rule-index]");
    const rewardSwiper = initSubSwiper(panel, "[data-reward-swiper]", "[data-reward-index]");
    childSwipers.push({ ruleSwiper, rewardSwiper });

    const contentElement = panel.querySelector("[data-page-slider]");
    const menuButtons = Array.from(panel.querySelectorAll("[data-section-index]"));
    const contentSwiper = new Swiper(contentElement, {
      ...SWIPER_OPTIONS,
      initialSlide: 0,
    });

    menuButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        contentSwiper.slideTo(Number(button.dataset.sectionIndex || 0));
      });
    });

    panel.addEventListener("click", (event) => {
      const button = event.target.closest("[data-go-section]");
      if (!button || !panel.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();
      contentSwiper.slideTo(Number(button.dataset.goSection || 0));
    });

    const syncContent = () => {
      syncButtons(menuButtons, contentSwiper.activeIndex);
      if (contentSwiper.activeIndex === 1) ruleSwiper?.update();
      if (contentSwiper.activeIndex === 3) rewardSwiper?.update();
    };

    contentSwiper.on("slideChange", syncContent);
    syncContent();
    contentSwipers.push(contentSwiper);
    initCalendar(panel);
  });

  const tournamentElement = root.querySelector("[data-game-slider]");
  const tournamentButtons = Array.from(root.querySelectorAll("[data-tournament-index]"));
  const tournamentSwiper = new Swiper(tournamentElement, {
    ...SWIPER_OPTIONS,
    initialSlide: 0,
  });

  tournamentButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      tournamentSwiper.slideTo(Number(button.dataset.tournamentIndex || 0));
    });
  });

  const syncTournament = () => {
    const activeIndex = tournamentSwiper.activeIndex;
    syncButtons(tournamentButtons, activeIndex);
    contentSwipers[activeIndex]?.update();
    childSwipers[activeIndex]?.ruleSwiper?.update();
    childSwipers[activeIndex]?.rewardSwiper?.update();
  };

  tournamentSwiper.on("slideChange", syncTournament);
  syncTournament();

  const navToggle = root.querySelector(".nav-toggle");
  const tournamentTabs = root.querySelector("[data-game-tabs]");

  navToggle?.addEventListener("click", (event) => {
    event.preventDefault();
    const isCollapsed = root.classList.toggle("is-nav-collapsed");

    navToggle.setAttribute("aria-expanded", String(!isCollapsed));
    navToggle.setAttribute(
      "aria-label",
      isCollapsed ? "Mở danh sách giải đấu" : "Thu gọn danh sách giải đấu",
    );
    tournamentTabs?.setAttribute("aria-hidden", String(isCollapsed));
    tournamentTabs?.toggleAttribute("inert", isCollapsed);
  });

  root.classList.add("is-ready");
});
